export const url = "https://app.trcpowertech.in/api";
export const IMAGE_URL =
  "https://app.trcpowertech.in/api/image/upload-image";
export const IMAGE_BASE_URL =
  "https://app.trcpowertech.in/api/image/get-image";
